// extracted by mini-css-extract-plugin
export default {"button":"link_button__T0swB","clone":"link_clone__f0P1m","text":"link_text__w7G5n"};